var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0512 3.70822C14.9425 3.40602 14.6267 3.25577 14.3456 3.37268C13.1957 3.85106 12.1201 4.51001 11.1294 5.28458C10.1384 6.06038 9.23036 6.95305 8.40994 7.93187C7.58999 8.9113 6.85688 9.97791 6.227 11.1188C5.88982 11.7306 5.5825 12.3643 5.31009 13.0182C5.12462 12.7913 4.93351 12.5706 4.73495 12.357C4.42767 12.0269 4.10433 11.7123 3.76037 11.4186C3.4162 11.1252 3.05142 10.8519 2.65648 10.6149C2.36424 10.4391 1.98965 10.5243 1.79071 10.8243C1.57733 11.146 1.64689 11.5929 1.94602 11.8224L1.95364 11.8283C2.24833 12.0544 2.52883 12.3172 2.79477 12.6007C3.06071 12.8845 3.31235 13.1895 3.54964 13.508C3.78683 13.8265 4.00993 14.1588 4.21564 14.4996C4.42089 14.84 4.61022 15.1908 4.76793 15.5368C4.86599 15.7508 5.03778 15.9288 5.26166 16.0198C5.73013 16.2102 6.2533 15.956 6.43026 15.4521L6.4741 15.3272C6.75439 14.1831 7.16848 13.0632 7.68601 11.995C8.20417 10.9268 8.82555 9.90893 9.53345 8.96401C10.2417 8.01948 11.0371 7.1468 11.9117 6.37981C12.7861 5.61377 13.7412 4.95252 14.764 4.45596L14.7682 4.45394C15.0296 4.32636 15.156 3.9998 15.0512 3.70822Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.95389319.svg";
export { ForwardRef as ReactComponent };